import { FC } from 'react';
import { Box } from '@mui/material';
import ContentPage from './Content';

const AboutPage: FC = () => {
  return (
    <Box>
      <ContentPage id="4MQcUAxH4Y9lei9RVlLrHe" />
    </Box>
  );
};

export default AboutPage;
